import { ImageModel } from './../models/image.model';
import { PasswordModel } from '../models/password.model';
import { LoginModel, TokenModel, RegisterModel } from '../models/login.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { UserModel } from '../models/user.model';
import { environment } from '../../environments/environment';
import Auth from '../helpers/auth';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthService extends AppService<TokenModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  private accountModel = new Subject<any>();

  getAccountModel(): Observable<any> {
    return this.accountModel.asObservable();
  }

  private setUserInLocalStorate(user) {
    localStorage.setItem('user', btoa(user));

    const image = new ImageModel();
    const _user = Auth.getUser();
    image.url = `${environment.blobUrl}/${_user.id}.png?v=${new Date().getTime()}`;
    _user.foto = image;
    localStorage.setItem('user', btoa(JSON.stringify(_user)));
  }

  private setTokenInLocalStorage(token) {
    localStorage.setItem('token', btoa(token));
  }

  async signIn(user: LoginModel): Promise<TokenModel> {
    const body = new HttpParams()
    .set('grant_type', 'password')
    .set('username', user.username)
    .set('password', user.password);
    const token = await this.signInAsync(body.toString())
      .then((success: TokenModel) => {
        this.setUserInLocalStorate(success.usuarioMeep);
        this.setTokenInLocalStorage(success.access_token);
        return success;
      });
    return <TokenModel>token;
  }

  async register(user: RegisterModel) {
    const result = await this.postAsync('Account/Register', user);
    return result;
  }

  async update(user: UserModel) {
    const result = await this.postAsync('Account/Update', user)
      .then(success => {
        if (user.foto) {
          success.foto = user.foto;
        }
        this.setUserInLocalStorate(JSON.stringify(success));
        this.accountModel.next();
        return success;
      });
      return result;
  }

  async changePassword(password: PasswordModel) {
    const result = await this.postAsync('Account/AlterarSenha', password);
      return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/auth.service.ts